import React from "react";
import { Link } from "react-router-dom";

import "./Button.scss";

interface ButtonProps<T = any> {
  onClick?: (data: T) => void | Promise<void>;
  className?: string;
  disabled?: boolean;
  type?: "submit" | "button" | "reset";
  mode?: "danger" | "grey";
  size?: "small" | "normal";
  to?: string;
}

export const Button: React.FC<ButtonProps> = React.memo(
  ({ children, onClick, className, disabled, type, mode, size, to }) => {
    return (
      <div className={["button", className, disabled && "disabled", mode, size].filter(Boolean).join(" ")}>
        {children}
        {to ? (
          <Link
            to={to}
            className="button__top"
            aria-disabled={disabled || undefined}
            tabIndex={disabled ? -1 : undefined}
            onClick={(event) => {
              if (disabled) {
                event.preventDefault();
              } else {
                onClick?.(event);
              }
            }}
          >
            {children}
          </Link>
        ) : (
          <button type={type} className="button__top" onClick={onClick} disabled={disabled}>
            {children}
          </button>
        )}
        <div className="button__back">{children}</div>
      </div>
    );
  }
);
